import React from 'react'

export default function TimeIcon({ color = "#789CB0", size = 14 }: { color?: string; size?: number } = {}){
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 14 14" fill="none">
            <path d="M7 0C10.8661 0 14 3.1339 14 7C14 10.8661 10.8661 14 7 14C3.1339 14 0 10.8661 0 7C0 3.1339 3.1339 0 7 0ZM7 2.8C6.81435 2.8 6.6363 2.87375 6.50503 3.00503C6.37375 3.1363 6.3 3.31435 6.3 3.5V7C6.30004 7.18564 6.37382 7.36365 6.5051 7.4949L8.6051 9.5949C8.73712 9.72241 8.91394 9.79297 9.09748 9.79137C9.28102 9.78978 9.45659 9.71616 9.58637 9.58637C9.71616 9.45659 9.78978 9.28102 9.79137 9.09748C9.79297 8.91394 9.72241 8.73712 9.5949 8.6051L7.7 6.7102V3.5C7.7 3.31435 7.62625 3.1363 7.49497 3.00503C7.3637 2.87375 7.18565 2.8 7 2.8Z" fill={color}/>
        </svg>
    )
}
